const defaultValues = {
  /** Array of open modals */
  openModals: [],
  /** Set open modals */
  setOpenModals: (newValue = []) => {},
};
Object.freeze(defaultValues);

export default defaultValues;
